<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="700px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Claim Entitlement Setting"
      text="Edit Claim Entitlement Setting"
      class="mb-0"
    > 
      <form v-if="dialog">
        <v-container>
          <v-row no-gutters>
            <v-col cols="12">
              <v-text-field
                v-model="localClaimEntitlementSetting.name"
                v-validate="'required'"
                :error-messages="errors.collect('name')"
                data-vv-name="name"                
                label="Name"
              />
            </v-col>

            <v-col cols="12">
              <v-autocomplete 
                v-model="localClaimEntitlementSetting.claim_type_id"
                v-validate=" 'required'"
                :items="claimTypes"
                :error-messages="errors.collect('claim_type_id')"
                data-vv-name="claim_type_id"      
                data-vv-as="claim type"
                label="Claim Type"
                item-text="name"      
                item-value="id"      
              />
            </v-col>

            <v-col cols="12">
              <v-autocomplete
                v-model="localClaimEntitlementSetting.credit_unit"
                v-validate="'required'"
                :items="creditUnits"
                label="Credit Unit"
                :error-messages="errors.collect('credit_unit')"
                data-vv-name="credit_unit"   
                data-vv-as="credit unit"   
                item-text="name"
                item-value="name"
              />
            </v-col>

            <v-col
              v-if="localClaimEntitlementSetting.credit_unit === 'day'"
              cols="6"
            >
              <span> Includes end date? </span>
              <v-radio-group
                v-model="localClaimEntitlementSetting.includes_end_date"
                class="mt-0"
                row
              >
                <v-radio
                  label="No"
                  :value="0"
                />
                <v-radio
                  label="Yes"
                  :value="1"
                />
              </v-radio-group>
            </v-col>

            <v-col
              v-if="localClaimEntitlementSetting.credit_unit === 'day' && localClaimEntitlementSetting.includes_end_date"
              cols="6"
            >
              <span> Allow claim half entitlement? </span>
              <v-radio-group
                v-model="localClaimEntitlementSetting.allow_claim_half_entitlement"
                class="mt-0"
                row
              >
                <v-radio
                  label="No"
                  :value="0"
                />
                <v-radio
                  label="Yes"
                  :value="1"
                />
              </v-radio-group>
            </v-col>

            <v-col
              v-if="localClaimEntitlementSetting.credit_unit === 'day' && !localClaimEntitlementSetting.allow_claim_half_entitlement"
              cols="6"
            >
              <span> Allow combine entitlement? </span>
              <v-radio-group
                v-model="localClaimEntitlementSetting.allow_combine_entitlement"
                class="mt-0"
                row
              >
                <v-radio
                  label="No"
                  :value="0"
                />
                <v-radio
                  label="Yes"
                  :value="1"
                />
              </v-radio-group>
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"
          class="white--text"
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      setting: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        dialog: false,
        progressing: false,
        localClaimEntitlementSetting: {},
        claimTypes: [],
        creditUnits: ['day', 'month', 'year'],
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return       
        this.loadClaimTypes()
        this.localClaimEntitlementSetting = { ...this.setting }
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 
        
            this.progressing = true

            this.$api.claimEntitlementSettings().update(this.localClaimEntitlementSetting.id, this.prepareFormData())
              .then(res => {
                this.$emit('updated')
                this.dialog = false
                this.$snack({ message: 'Claim Entitlement Setting Updated Successfully' })
              })
              .catch(() => {
                this.$snack({ color: 'error', message: 'Unable to update claim entitlement setting' })
              })
              .then(() => {
                this.progressing = false
              })
          })
      },
      prepareFormData () {
        return {
          name: this.localClaimEntitlementSetting.name,
          claim_type_id: this.localClaimEntitlementSetting.claim_type_id,
          credit_unit: this.localClaimEntitlementSetting.credit_unit,
          includes_end_date: this.localClaimEntitlementSetting.credit_unit === 'day' ? this.localClaimEntitlementSetting.includes_end_date : 1,
          allow_claim_half_entitlement: this.localClaimEntitlementSetting.credit_unit === 'day' && this.localClaimEntitlementSetting.includes_end_date ? this.localClaimEntitlementSetting.allow_claim_half_entitlement : 0,
          is_fixed_amount: this.localClaimEntitlementSetting.credit_unit === 'day' && this.localClaimEntitlementSetting.includes_end_date ? this.localClaimEntitlementSetting.allow_claim_half_entitlement : 0,
          allow_combine_entitlement: this.localClaimEntitlementSetting.credit_unit === 'day' && !this.localClaimEntitlementSetting.allow_claim_half_entitlement ? this.localClaimEntitlementSetting.allow_combine_entitlement : 0,
        }
      },
      loadClaimTypes () {
        this.$api.claimTypes().list()
          .then(res => {
            this.claimTypes = res.data.filter(claimType => {
              return claimType.has_limit === 1
            }) 
          })
      },
    },
  }
</script>
